/* universanet.js - Universanet Store Theme JavaScript */
(function() {
  'use strict';

  /* ---- Utility ---- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function off(el, ev, fn) { if (el) el.removeEventListener(ev, fn); }
  function emit(el, ev, detail) { el.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: detail || {} })); }

  /* ---- Toast Notifications ---- */
  var toastContainer = null;
  function getToastContainer() {
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.className = 'toast-container';
      document.body.appendChild(toastContainer);
    }
    return toastContainer;
  }
  function showToast(msg, type, duration) {
    var container = getToastContainer();
    var toast = document.createElement('div');
    toast.className = 'toast ' + (type || 'success');
    toast.innerHTML = '<span>' + msg + '</span>';
    container.appendChild(toast);
    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
      toast.style.transition = 'all .3s ease';
      setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
    }, duration || 3500);
  }

  /* ---- Sticky Header ---- */
  function initStickyHeader() {
    var header = qs('.site-header');
    if (!header) return;
    var scrolled = false;
    function update() {
      var shouldScrolled = window.scrollY > 10;
      if (shouldScrolled !== scrolled) {
        scrolled = shouldScrolled;
        header.classList.toggle('scrolled', scrolled);
      }
    }
    on(window, 'scroll', update, { passive: true });
    update();
  }

  /* ---- Mobile Drawer Nav ---- */
  function initMobileDrawer() {
    var overlay = qs('.mobile-drawer-overlay');
    var drawer = qs('.mobile-drawer');
    var openBtn = qs('.hamburger-btn');
    var closeBtn = qs('.drawer-close');
    if (!overlay || !drawer) return;
    function openDrawer() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }
    on(openBtn, 'click', openDrawer);
    on(closeBtn, 'click', closeDrawer);
    on(overlay, 'click', function(e) { if (e.target === overlay) closeDrawer(); });
    on(document, 'keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---- Cart Drawer ---- */
  function initCartDrawer() {
    var overlay = qs('.cart-drawer-overlay');
    var drawer = qs('.cart-drawer');
    var openBtns = qsa('[data-open-cart]');
    var closeBtn = qs('.cart-drawer-close');
    if (!overlay || !drawer) return;
    function openCartDrawer() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      fetchCartDrawer();
    }
    function closeCartDrawer() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }
    openBtns.forEach(function(btn) { on(btn, 'click', openCartDrawer); });
    on(closeBtn, 'click', closeCartDrawer);
    on(overlay, 'click', function(e) { if (e.target === overlay) closeCartDrawer(); });
    on(document, 'keydown', function(e) { if (e.key === 'Escape') closeCartDrawer(); });
    window.openCartDrawer = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
  }

  function fetchCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); })
      .catch(function() { console.warn('Could not fetch cart'); });
  }

  function renderCartDrawer(cart) {
    var body = qs('.cart-drawer-body');
    var subtotalEl = qs('.cart-drawer-subtotal span:last-child');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty-msg"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn-primary">Shop Now</a></div>';
    } else {
      var html = cart.items.map(function(item) {
        return '<div class="cart-item-drawer">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '') +
          '<div class="cart-item-info">' +
          '<div class="cart-item-title">' + item.title + '</div>' +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div style="font-size:13px;color:var(--graphite);margin-top:4px;">Qty: ' + item.quantity + '</div>' +
          '</div></div>';
      }).join('');
      body.innerHTML = html;
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateCartCount(cart.item_count);
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    qsa('.cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ---- Add to Cart AJAX ---- */
  function initAddToCart() {
    on(document, 'click', function(e) {
      var btn = e.target.closest('.btn-atc[data-product-id], [data-ajax-atc]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId || btn.dataset.productId;
      if (!variantId) return;
      var qty = parseInt(btn.dataset.qty || 1);
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Cart error');
        return r.json();
      })
      .then(function(item) {
        showToast(item.title + ' added to cart!', 'success');
        fetchCartDrawer();
        if (window.openCartDrawer) window.openCartDrawer();
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      })
      .catch(function(err) {
        showToast('Could not add to cart. Please try again.', 'error');
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
    });
  }

  /* ---- Product Form (full page) ---- */
  function initProductForm() {
    var form = qs('.product-form');
    if (!form) return;
    on(form, 'submit', function(e) {
      e.preventDefault();
      var btn = qs('[type=submit]', form);
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
      .then(function(r) {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function(item) {
        showToast(item.title + ' added to cart!', 'success');
        fetchCartDrawer();
        if (window.openCartDrawer) window.openCartDrawer();
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      })
      .catch(function() {
        showToast('Could not add item. Please try again.', 'error');
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      });
    });
  }

  /* ---- Product Gallery Switcher ---- */
  function initProductGallery() {
    var mainImg = qs('.gallery-main-img');
    var thumbs = qsa('.gallery-thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function(thumb) {
      on(thumb, 'click', function() {
        var src = thumb.dataset.src;
        if (src) mainImg.src = src;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ---- Quantity Stepper ---- */
  function initQuantitySteppers() {
    on(document, 'click', function(e) {
      var btn = e.target.closest('.qty-btn');
      if (!btn) return;
      var input = btn.closest('.quantity-selector') && qs('.qty-input', btn.closest('.quantity-selector'));
      if (!input) return;
      var val = parseInt(input.value) || 1;
      var delta = btn.dataset.delta === '-1' ? -1 : 1;
      var min = parseInt(input.min) || 1;
      var max = parseInt(input.max) || 999;
      input.value = Math.min(max, Math.max(min, val + delta));
      emit(input, 'change');
    });
  }

  /* ---- Variant Selector / Price Update ---- */
  function initVariantSelector() {
    var form = qs('.product-form');
    if (!form) return;
    var variantSelect = qs('select[name="id"]', form);
    var variantOptions = qsa('.variant-option', form);
    var priceEl = qs('.product-price');
    var compareEl = qs('.product-compare');
    var variantIdInput = qs('input[name="id"]', form);

    if (variantOptions.length) {
      variantOptions.forEach(function(opt) {
        on(opt, 'click', function() {
          var group = opt.closest('.variant-options');
          if (group) qsa('.variant-option', group).forEach(function(o) { o.classList.remove('active', 'selected'); });
          opt.classList.add('active', 'selected');
        });
      });
    }

    if (variantSelect && priceEl) {
      on(variantSelect, 'change', function() {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (option && option.dataset.price) {
          priceEl.textContent = formatMoney(parseInt(option.dataset.price));
        }
        if (variantIdInput) variantIdInput.value = variantSelect.value;
      });
    }
  }

  /* ---- Tab Switching ---- */
  function initTabs() {
    on(document, 'click', function(e) {
      var btn = e.target.closest('[data-tab-target]');
      if (!btn) return;
      var target = btn.dataset.tabTarget;
      var container = btn.closest('[data-tab-container]');
      if (!container) return;
      qsa('[data-tab-target]', container).forEach(function(b) { b.classList.remove('active'); });
      qsa('[data-tab-panel]', container).forEach(function(p) { p.style.display = 'none'; });
      btn.classList.add('active');
      var panel = qs('[data-tab-panel="' + target + '"]', container);
      if (panel) panel.style.display = 'block';
    });
  }

  /* ---- Newsletter Form ---- */
  function initNewsletterForm() {
    var form = qs('.newsletter-form');
    if (!form) return;
    on(form, 'submit', function(e) {
      e.preventDefault();
      var input = qs('input[type=email]', form);
      var msg = qs('.newsletter-msg');
      var btn = qs('button[type=submit]', form);
      if (!input || !input.value) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Subscribing...'; }
      setTimeout(function() {
        if (msg) { msg.textContent = 'Thank you for subscribing! 🎉'; msg.style.color = '#22c55e'; }
        input.value = '';
        if (btn) { btn.disabled = false; btn.textContent = 'Subscribe'; }
      }, 800);
    });
  }

  /* ---- Cart Page Qty Update ---- */
  function initCartPage() {
    var cartForm = qs('form[action="/cart"]');
    if (!cartForm) return;
    on(cartForm, 'change', function(e) {
      if (e.target.classList.contains('qty-input') || e.target.name && e.target.name.includes('updates')) {
        cartForm.submit();
      }
    });
  }

  /* ---- Smooth Scroll ---- */
  function initSmoothScroll() {
    on(document, 'click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = qs(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ---- Image Lazy Load ---- */
  function initLazyImages() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    qsa('img[data-src]').forEach(function(img) { observer.observe(img); });
  }

  /* ---- Search Toggle ---- */
  function initSearchToggle() {
    var toggleBtn = qs('[data-search-toggle]');
    var searchBar = qs('.header-search-bar');
    if (!toggleBtn || !searchBar) return;
    on(toggleBtn, 'click', function() {
      var open = searchBar.classList.toggle('open');
      if (open) {
        var input = qs('input', searchBar);
        if (input) input.focus();
      }
    });
  }

  /* ---- Address Form Toggle ---- */
  function initAddressForm() {
    var addBtn = qs('[data-new-address]');
    var form = qs('[data-address-form]');
    if (!addBtn || !form) return;
    form.style.display = 'none';
    on(addBtn, 'click', function() {
      form.style.display = form.style.display === 'none' ? 'block' : 'none';
    });
    var deleteBtns = qsa('[data-delete-address]');
    deleteBtns.forEach(function(btn) {
      on(btn, 'click', function() {
        if (confirm('Delete this address?')) {
          var url = btn.dataset.deleteAddress;
          fetch(url, { method: 'DELETE' }).then(function() { location.reload(); });
        }
      });
    });
  }


  /* ---- Hero Slideshow ---- */
  function initHeroSlider() {
    var slidesEl = qs('#heroSlides');
    if (!slidesEl) return;
    var slides = qsa('.hero-slide', slidesEl);
    if (slides.length < 2) return;

    var dotsEl = qs('#heroDots');
    var prevBtn = qs('#heroPrev');
    var nextBtn = qs('#heroNext');
    var current = 0;
    var timer = null;
    var interval = 5000;

    // Try to read interval from settings attribute
    var settingEl = qs('[data-slide-interval]');
    if (settingEl) interval = (parseInt(settingEl.dataset.slideInterval, 10) || 5) * 1000;

    // Build dots
    slides.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      on(dot, 'click', function() { goTo(i); });
      if (dotsEl) dotsEl.appendChild(dot);
    });

    function getDots() { return dotsEl ? qsa('.hero-dot', dotsEl) : []; }

    function goTo(idx) {
      slides[current].classList.remove('active');
      getDots()[current] && getDots()[current].classList.remove('active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('active');
      getDots()[current] && getDots()[current].classList.add('active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    if (prevBtn) on(prevBtn, 'click', function() { prev(); startAuto(); });
    if (nextBtn) on(nextBtn, 'click', function() { next(); startAuto(); });

    // Touch swipe
    var touchStartX = 0;
    on(slidesEl, 'touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    on(slidesEl, 'touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); startAuto(); }
    });

    startAuto();
  }

  /* ---- Init All ---- */
  function init() {
    initStickyHeader();
    initMobileDrawer();
    initCartDrawer();
    initAddToCart();
    initProductForm();
    initProductGallery();
    initQuantitySteppers();
    initVariantSelector();
    initTabs();
    initNewsletterForm();
    initCartPage();
    initSmoothScroll();
    initLazyImages();
    initSearchToggle();
    initAddressForm();
    fetchCartDrawer();
    initHeroSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
